import { LogoWrapper } from './styled'
import { LogoProps } from './types'

const Logo = ({ maxWidth, margin, src }: LogoProps) => {
  return <LogoWrapper maxWidth={maxWidth} margin={margin} src={src} />
}

export default Logo
